/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ resource: NonNullable<unknown> }} Duplicate_AlertInputs */



/**
* | resource | output |
* | --- | --- |
* | "airHandlerUnit" | "User plannings already present in the selected units will be deleted" |
* | "network" | "User plannings already present in the selected networks will be deleted" |
* | "room" | "User plannings already present in the selected rooms will be deleted" |
* | * | "User plannings already present in the selected rooms will be deleted" |
*
* @param {Duplicate_AlertInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const duplicate_alert = /** @type {((inputs: Duplicate_AlertInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Duplicate_AlertInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.resource === "airHandlerUnit") return /** @type {LocalizedString} */ (`User plannings already present in the selected units will be deleted`);
		if (i?.resource === "network") return /** @type {LocalizedString} */ (`User plannings already present in the selected networks will be deleted`);
		if (i?.resource === "room") return /** @type {LocalizedString} */ (`User plannings already present in the selected rooms will be deleted`);
		return /** @type {LocalizedString} */ (`User plannings already present in the selected rooms will be deleted`)
	}
	{
		if (i?.resource === "airHandlerUnit") return /** @type {LocalizedString} */ (`Les plannings utilisateurs déjà présents dans les équipements sélectionnés seront supprimés`);
		if (i?.resource === "network") return /** @type {LocalizedString} */ (`Les plannings utilisateurs déjà présents dans les réseaux sélectionnés seront supprimés`);
		if (i?.resource === "room") return /** @type {LocalizedString} */ (`Les plannings utilisateurs déjà présents dans les pièces sélectionnées seront supprimés`);
		return /** @type {LocalizedString} */ (`Les plannings utilisateurs déjà présents dans les pièces sélectionnées seront supprimés`)
	}
});